import {
  GenericCollectionReference,
  GenericDocumentReference,
  IApiCRUDBy,
  IApiTask,
  ICRUDBy,
  IRawDeviation,
  IRelatives,
} from "@propely/propely-typings";
import { DeviationData } from "to-be-removed/LocalData/Deviation/DeviationData";

export type CombinedDeviation = {
  rawData: IRawDeviation;
  deviationData: DeviationData;
};

export const convertApiTaskToRawTask = (apiTask: IApiTask): IRawDeviation => {
  const relatives: IRelatives = {};
  Object.entries(apiTask.relatives ?? {}).forEach(([key, value]) => {
    relatives[key] = {
      ...value,
      reference: value.reference ? generateGenericDocumentReference(value.reference) : undefined,
    };
  });

  const seenBy: Record<string, { date: Date }> = {};
  Object.entries(apiTask.seenBy ?? {}).forEach(([key, value]) => {
    seenBy[key] = {
      date: new Date(value.date),
    };
  });

  return {
    ...apiTask,
    deadline: apiTask.deadline ? new Date(apiTask.deadline) : undefined,
    reportDate: new Date(apiTask.reportDate),
    relatives: relatives,
    customTaskType: apiTask.customTaskType ? generateGenericDocumentReference(apiTask.customTaskType) : undefined,
    lastUpdate: apiTask.lastUpdate ? new Date(apiTask.lastUpdate) : undefined,
    seenBy: seenBy,
    startDate: apiTask.startDate ? new Date(apiTask.startDate) : undefined,
    deletedBy: apiTask.deletedBy ? convertCrudBy(apiTask.deletedBy) : undefined,
    createdBy: apiTask.createdBy ? convertCrudBy(apiTask.createdBy) : undefined,
    updatedBy: apiTask.updatedBy ? convertCrudBy(apiTask.updatedBy) : undefined,
  };
};

const convertCrudBy = (crudBy: IApiCRUDBy): ICRUDBy => {
  return {
    ...crudBy,
    date: crudBy.date ? new Date(crudBy.date) : undefined,
  };
};

const generateGenericDocumentReference = (path: string): GenericDocumentReference => {
  const paths = path.split("/");
  const id = paths[paths.length - 1];
  const parentPath = paths.slice(0, paths.length - 1).join("/");
  const parent = generateGenericCollectionReference(parentPath);
  return {
    id,
    path,
    parent,
  };
};

const generateGenericCollectionReference = (path: string): GenericCollectionReference => {
  const paths = path.split("/");
  const id = paths[paths.length - 1];
  const parentPath = paths.slice(0, paths.length - 1).join("/");
  const parent = parentPath ? generateGenericDocumentReference(parentPath) : null;
  return {
    id,
    path,
    parent,
  };
};
